import { useEffect, useState } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { promptApi } from '../../api/media';

export function PromptEditorPage() {
  const { id } = useParams();
  const navigate = useNavigate();
  const isNew = !id || id === 'new';
  const [name, setName] = useState('');
  const [content, setContent] = useState('');
  const [model, setModel] = useState('');
  const [isTemplate, setIsTemplate] = useState(false);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (isNew || !id) return;
    void promptApi.list().then((items) => {
      const p = items.find((x) => x.id === id);
      if (p) {
        setName(p.name);
        setContent(p.content);
        setModel(p.model || '');
        setIsTemplate(!!p.is_template);
      }
    });
  }, [id, isNew]);

  async function save(e: React.FormEvent) {
    e.preventDefault();
    setLoading(true);
    try {
      const payload = { name, content, model, is_template: isTemplate };
      const p = isNew ? await promptApi.create(payload) : await promptApi.update(id!, payload);
      void navigate('/media/prompts');
      return p;
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Save failed');
    } finally {
      setLoading(false);
    }
  }

  async function generate() {
    if (isNew || !id) return;
    setLoading(true);
    try {
      await promptApi.generate({ prompt_id: id, create_asset: true });
      void navigate('/media/generations');
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Generation failed');
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="mx-auto max-w-2xl p-6">
      <Link to="/media/prompts" className="text-sm text-slate-600 hover:underline">← Prompt library</Link>
      <h1 className="mt-4 text-2xl font-semibold">{isNew ? 'New Prompt' : 'Edit Prompt'}</h1>
      <form onSubmit={(e) => void save(e)} className="mt-6 space-y-4">
        <input required value={name} onChange={(e) => setName(e.target.value)} placeholder="Prompt name" className="w-full rounded-lg border px-3 py-2" />
        <textarea required value={content} onChange={(e) => setContent(e.target.value)} placeholder="Prompt content" rows={6} className="w-full rounded-lg border px-3 py-2 font-mono text-sm" />
        <input value={model} onChange={(e) => setModel(e.target.value)} placeholder="Model (optional)" className="w-full rounded-lg border px-3 py-2" />
        <label className="flex items-center gap-2 text-sm">
          <input type="checkbox" checked={isTemplate} onChange={(e) => setIsTemplate(e.target.checked)} />
          Save as template
        </label>
        {error && <p className="text-sm text-red-600">{error}</p>}
        <div className="flex gap-3">
          <button type="submit" disabled={loading} className="rounded-lg bg-slate-900 px-4 py-2 text-sm text-white">Save</button>
          {!isNew && (
            <button type="button" disabled={loading} onClick={() => void generate()} className="rounded-lg border px-4 py-2 text-sm">Generate asset</button>
          )}
        </div>
      </form>
    </div>
  );
}
